import React from "react";

const Redo = ({ customComponent, onClick, isActive, isDisabled }) => {
	const doRedo = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={doRedo}
				title="Redo"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-redo" />}
			</button>
		</>
	);
};

export default Redo;
